import { MEDIA_ACCESS } from '@/helpers/permissionsConstant'

export default [
  {
    title: 'Media Library',
    route: 'admin-media',
    icon: 'ImageIcon',
    gate: MEDIA_ACCESS,
  },
]